import { isPlanLimitError } from "@/common/lib/formatter";

// billing-fase5-salida-planes: al crear por encima del tope del plan el
// backend responde 422 PLAN_LIMIT_REACHED. En vez del $swal de error se abre
// el modal "Pásate a…". Devuelve true si lo manejó.
export default {
    methods: {
        openPlanUpgradeForLimit(error) {
            if (!isPlanLimitError(error)) return false;
            this.$store.dispatch("platformSubscriptions/openPlanUpgrade", {
                kind: "limit",
                ...error.data
            });
            return true;
        }
    }
};
